export default __webpack_public_path__ + "static/media/acient-greek-pirates.9f6b4417.jpg";